import i18n from "~/plugins/i18n";
export default {
    fields: [
        {
            key: "id",
            label: "#",
            sorter: true,
            filter: false,
            _filter: false,
        },
        {
            key: "name",
            label: "name",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
        },
        {
            key: "total",
            label: "total",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
        }
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 1,
    loading: true,
    hover: true,
    pagination: true,
    sorter: {
        external: true,
        resetable: true
    },
    sorterValue: {},
    size: "sm",
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null
}